import { render, staticRenderFns } from "./contentUserAllGroupTurnOffStatus.vue?vue&type=template&id=bb4d0e12&"
import script from "./contentUserAllGroupTurnOffStatus.vue?vue&type=script&lang=js&"
export * from "./contentUserAllGroupTurnOffStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports